import { atom } from 'recoil'
import { IFaqArticle, IFaqCategory } from './faq.types'

interface IFaqAtomState {
  categories: IFaqCategory[]
  articles: IFaqArticle[]
  loaded: boolean
}

const faqAtom = atom<IFaqAtomState>({ key: 'support/faq', default: { categories: [], articles: [], loaded: false } })
export default faqAtom
